export const checkDateStatus = (date: string) => {

    date = !date ? "19.9.1999" : date;

    let dateStatus = "";

    // Split the date in days, months and years
    const [d, m, y] = date.split(".");
    // Build dateToCheck from Date, using y m d form
    const dateToCheckInMs = new Date(Number(y), Number(m) - 1, Number(d)).getTime();
    // Get current date in milliseconds
    const nowInMs = new Date().getTime();
    // Calculate five months in milliseconds
    const fiveMonthsInMs = 5 * 30 * 24 * 60 * 60 * 1000;

    if (nowInMs >= dateToCheckInMs) {
        // If current date is bigger than date to check
        dateStatus = "expired";
    } else if (nowInMs < dateToCheckInMs && (nowInMs + fiveMonthsInMs) > dateToCheckInMs) {
        // If current date is smaller than date to check, 
        // but current date + 5 months is larger than date to check
        dateStatus = "expiring";
    } else {
        // Otherwise date is more than 5 months in future
        dateStatus = "active";
    }
    return dateStatus;
};